import usePageTitle from '@hooks/usePageTitle';
import { useEffect } from 'react';
import { useAppSelector } from '@reduxStore';
import { useNavigate } from 'react-router';
import EdiLoadToaderDataGrid from '@components/DataGrid/EdiLoadTender/DataGrid';
import { selectAppFeatures, selectTerminal } from '@/Infrastructure/Utilities/appSelectors';

import styles from './EdiLoadTender.module.css';

export default function EdiLoadTenderPage() {
	const terminal = useAppSelector((state) => selectTerminal(state));
	const features = useAppSelector((state) => selectAppFeatures(state));
	const { addPageTitle } = usePageTitle();
	const navigate = useNavigate();

	useEffect(() => {
		addPageTitle('EDI Load Tenders');
	}, [addPageTitle]);

	if (!features?.ediLoadTendersPage) {
		void navigate('/');
	}

	return (
		<div
			className={styles.container}
			key={`${terminal?.number || '0'}-edi-tenders`}
		>
			<div className={styles['title-bar']}>
				<span className={styles.title}>EDI Load Tenders</span>
			</div>
			<div
				className={styles['edi-data-grid-container']}
				key={`${terminal?.number || '0'}-edi-load-tender-grid`}
			>
				<EdiLoadToaderDataGrid />
			</div>
		</div>
	);
}
